export const RoutingNumberFieldData = {
  formControlName: 'routingNumber',
  id: 'grit-field-routing-number',
  type: 'tel',
  maxLength: 9,
  label: 'Bank routing number',
  prefixIcon: {
    iconName: 'account_balance',
  },
  hint:
    'This is the first set of numbers at the bottom of your checks (left side).',
  requiredMessage:
    'Your bank routing number is required to process the application.',
  validationList: [
    {
      errorKey: 'minlength',
      message: 'Your bank routing number must contain 9 digits.',
      args: [9],
    },
    {
      errorKey: 'mod10',
      message:
        'Your bank routing number is invalid. Please double check and try again.',
    },
  ],
  validCharacters: '0123456789',
};
